const baseSoundsPath = (fileName: string) => `./src/assets/sounds/${fileName}`;

export const CLAIM_REWARDS_ANIMATION_SOUNDS = {
  rewards: baseSoundsPath('rewards.mp3'),
};
